import { PaymentParameters } from 'ha/services/apiV2/types/PaymentParameters';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from 'ha/services/apiV2/constants';

export default (makeCall: MakeCall) => (
  conversationId: number,
  countryCode: string,
) =>
  makeCall<PaymentParameters>(
    'GET',
    `${APIV2_URL}/conversation/${conversationId}/payment-parameters`,
    {
      query: { countryCode },
    },
  );
